<template>
  <div>
    <div class="container-fluid page-head-wrap" v-if="apiLoading">
      <div class="container page-head text-center">
        <p class="mb-0"><i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 14px; "></i> <trans-text i18nKey="ui['5_4_1'][101]"/></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
            <page-form :storeData="storeData" @changeIsOnlyThisTime="changeIsOnlyThisTime" ></page-form>
        </div>

        <template v-if="isMobileBreakpoint">
          <div class="offset-1 col-10 price-area mt-3">
              <ul class="size-info-mobile size-info list-unstyled my-1">
                <li>
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][21]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['91'][3]"/>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][22]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['91'][3]"/>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][23]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['91'][3]"/>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][24]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['91'][3]"/>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="offset-1 col-10 mt-3 price-info-wrap h-100">
              <div class="price-info d-flex flex-column h-100">
                <div class="price-label flex-grow-1">
                  <trans-text i18nKey="ui['6'][5]" />
                </div>
                <div class="price-value text-right">
                  <trans-text i18nKey="ui['9'][25]" :replaceData="{money:cartTotalPrice.total_price}" />
                </div>
              </div>
          </div>
        </template>

        <div class="col-lg-6">
          <div class="row order-no-area mt-3">
            <div class="col-12">
              <div class="order-no"><trans-text i18nKey="ui['9'][20]" /></div>
            </div>
          </div>
          <div class="row no-gutters" v-for="event of cartEvents">
            <div class="col-lg-6">
              <div class="event-name">
              <span class="info-label"><trans-text i18nKey="ui['9'][21]" />:</span> {{event.name}}
              </div>
            </div>
            <div class="col-lg-6">
              <div class="end-at">
              <span class="info-label"><trans-text i18nKey="ui['9'][22]" />:</span> {{event.end_date_disp}}
              </div>
            </div>
          </div>

          <!-- 写真一覧 -->
          <div class="row mx-1-gutters mt-3">
            <component :is="photoComponent(cartPhoto)" :cartPhoto="cartPhoto" :cart="cart" v-for="cartPhoto in cartPhotos" :key="cartPhoto.id"
                       :ref="'photoComponent_' + cartPhoto.id">
            </component>
          </div>

          <div class="row mx-1-gutters mt-1">
            <div class="offset-1 offset-lg-6 col-10 col-lg-6">
              <div class="mt-5">
                <router-link tag="button" :to="{ name: 'mypage::event::cart', params:{} }" class="btn w-100 btn-warning">
                  <trans-text i18nKey="ui[9][23]" :adjustLangFontSizes="{en:0.8}" />
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </div>
      <template v-if="!isMobileBreakpoint">
      <div class="row mt-3 " >
        <div class="col-6 px-4">
            <div class="row">
            <div class="col price-area">

              <ul class="size-info list-unstyled my-1">
                <li v-if="cartSizePrice['1_1']">
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][21]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['9'][28]" :replaceData="{quantity:cartSizePrice['1_1'].count}" />
                    </div>
                  </div>
                </li>
                <li v-if="cartSizePrice['1_2']">
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][22]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['9'][28]" :replaceData="{quantity:cartSizePrice['1_2'].count}" />
                    </div>
                  </div>
                </li>
                <li v-if="cartSizePrice['2_1']">
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][23]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['9'][28]" :replaceData="{quantity:cartSizePrice['2_1'].count}" />
                    </div>
                  </div>
                </li>
                <li v-if="cartSizePrice['2_2']">
                  <div class="row">
                    <div class="col-8">
                      <span class="size-label"><trans-text i18nKey="ui[7][24]"/>:</span>
                    </div>
                    <div class="col-4">
                      <trans-text i18nKey="ui['9'][28]" :replaceData="{quantity:cartSizePrice['2_2'].count}" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col py-1">
              <div class="price-info-wrap h-100">
                <div class="price-info d-flex flex-column h-100">
                  <div class="price-label flex-grow-1">
                    <trans-text i18nKey="ui['6'][5]" />
                  </div>
                  <div class="price-value text-right">
                    <trans-text i18nKey="ui['9'][25]" :replaceData="{money:cartTotalPrice.total_price}" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-3">
          <div class="mt-1">
            <button class="btn w-100 btn-warning" @click="commitOrder">
              <trans-text i18nKey="ui[9][26]" :adjustLangFontSizes="{en:0.8}" />
            </button>

            <!--<router-link tag="button" :to="{ name: 'mypage::event::demo_questionnaire', params:{} }" class="btn w-100 btn-warning">-->
              <!--<trans-text i18nKey="ui[9][26]" :adjustLangFontSizes="{en:0.8}" />-->
            <!--</router-link>-->
          </div>
          <div class="mt-2">
            <router-link tag="button" :to="{ name:'mypage::event::order_form', params:{} }" class="btn w-100 btn-default">
              <trans-text i18nKey="ui[9][27]"/>
            </router-link>
          </div>
        </div>

      </div>
      </template>
      <template v-else>
        <hr>
        <div class="row mx-1-gutters mt-1">
          <div class="offset-1 offset-lg-6 col-10 col-lg-6">
            <div class="mt-3">
              <button class="btn w-100 btn-warning" @click="commitOrder">
                <trans-text i18nKey="ui[9][26]" :adjustLangFontSizes="{en:0.8}" />
              </button>

              <!--<router-link tag="button" :to="{ name: 'mypage::event::demo_questionnaire', params:{} }" class="btn w-100 btn-warning">-->
                <!--<trans-text i18nKey="ui[9][26]" :adjustLangFontSizes="{en:0.8}" />-->
              <!--</router-link>-->
            </div>
          </div>
        </div>
        <div class="row mx-1-gutters mt-1 mb-4">
          <div class="offset-1 offset-lg-6 col-10 col-lg-6">
            <div class="mt-1">
              <router-link tag="button" :to="{ name:'mypage::event::order_form', params:{} }" class="btn w-100 btn-default">
                <trans-text i18nKey="ui[9][27]"/>
              </router-link>
            </div>
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import PageForm from 'page/partials/Order/Confirm/PageForm.vue'

  import GroupHorizonPhoto from 'page/partials/Order/Confirm/GroupHorizonPhoto.vue'
  import SnapHorizonPhoto from 'page/partials/Order/Confirm/SnapHorizonPhoto.vue'
  import SnapVerticalPhoto from 'page/partials/Order/Confirm/SnapVerticalPhoto.vue'

  import Cart from 'processor/Cart'

  export default {
    name:"",
    components: {
      PageForm,
      GroupHorizonPhoto,
      SnapHorizonPhoto,
      SnapVerticalPhoto,
    },
    data () {
      return {
        isOnlyThisTime:false,
        cartSizePrice:{},
        cartTotalPrice:{},
        storeData:{},
        cart:{},
        cartPhotos:{},
        apiLoading:true,

      }
    },
    created(){
    },
    methods:{
      changeIsOnlyThisTime(value){
          this.isOnlyThisTime = value
      },

      commitOrder(){

        let input = Object.assign(this.storeData,{isOnlyThisTime:this.isOnlyThisTime})
        app.make("axios").post(`v1/order-commit`,input)
          .then(({data}) =>{
            store.session({order_form:null})
            this.$router.push({ name: 'payment::form', params: {}})
          })
          .catch(error => {
//            console.log("b",error)
//            this.apiErrorI18nKey = "error[13][10]"
          })






//
//        Cart.commitOrder({"cart_id":this.cart.id})
//          .then((res) => {
//            if (res.status === "ng") {
//              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
//              return
//            }
//            store.session("order",res.data.order)
//            this.$router.push({ name: 'payment::form', params: {}})
//          })
      },
      photoComponent(cartPhoto){
        let photo = cartPhoto.photo || {}
        if(!photo.id){ return }
        let photoTypeCode = app.make("_").first(photo.photo_types).code
        let isVertically = app.make("_").first(photo.photo_thumbnails).is_vertically

        switch(String(photoTypeCode)){
          case "1": //スナップ
            return isVertically? "SnapVerticalPhoto" : "SnapHorizonPhoto"
          case "2": //集合写真
            return isVertically? "SnapVerticalPhoto" : "GroupHorizonPhoto"
        }
      },
    },
    computed: {
      isMobileBreakpoint(){
        switch(this.$root.bootstrapBreakpoint){
          case "xl":
          case "lg":
            return false
          case "md":
          case "sm":
          case "xs":
            return true
          default:
            return null
        }
      },
      cartEvents(){
        let rets = []
        app.make("_").each(this.cartPhotos, (cartPhoto) => {
          if (!cartPhoto.photo) {
            return
          }
          if (!cartPhoto.photo.event) {
            return
          }
          rets.push(cartPhoto.photo.event)
        })
        return app.make("_").uniqBy(rets, (item) => {
          return item.id
        })
      },
    },
    mounted(){

      let pageData = store.session("order_form")
      if(pageData) {
        this.storeData = pageData
      }else{
        //TODO ユーザー名のアップデート
        app.make("axios").get(`v1/current-order`,{})
          .then((res)=> {
            let orderer = res.data.order_orderers[0]
            let buyerUser = res.data.buyer_user
            let input = {
              family_name: orderer.family_name,
              given_name: orderer.given_name,
              address_1: orderer.address_1,
              address_2: orderer.address_2,
              city: orderer.city,
              prefecture: orderer.prefecture,
              zip_code: orderer.zip_code,
              country_name: orderer.country_name,
              phone_nunber: orderer.phone_nunber,
              email: buyerUser.email,
            }

            let orderEvents = res.data.order_events
            let child_info_input = []
            for (let orderEvent of orderEvents) {
              child_info_input.push({
                event_name: orderEvent.event.name,
                event_id: orderEvent.event.id,
                school_name: orderEvent.event.id,
                child_info_id: orderEvent.order_event_participants[0].original_participant_id,
                family_name: orderEvent.order_event_participants[0].family_name,
                given_name: orderEvent.order_event_participants[0].given_name,
                group_name: orderEvent.order_event_participants[0].group_name,
                family_relation_id: orderEvent.order_event_participants[0].family_relation_id,
              })
            }
            store.session({order_form: {input, child_info_input}})
            let pageData = store.session("order_form")
            this.storeData = pageData
          })
      }

      Promise.all([
        app.make("axios").get(`v1/cart-size-price`,{}),
        app.make("axios").get(`v1/cart-total-price`,{}),
      ]).then( ([cartSizePrice, cartTotalPrice]) => {
        this.cartSizePrice = cartSizePrice.data
        this.cartTotalPrice = cartTotalPrice.data
      });

      Cart.cartPreparation()
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.cart = res.data.cart
          return Cart.getPurchaseTargetCartPhotos({"cart_id":this.cart.id})
        })
        .then((res) => {
          if (res.status === "ng") {
            this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
            return
          }
          this.cartPhotos = res.data.cart_photos
          this.apiLoading = false
        })
    },
  }
</script>


<style lang="scss" scoped>
  .order-no {
    background-color: #82ba1d;
    color: #fff;
    font-size: 0.9rem;
    font-weight: bold;
    padding: .1rem .5rem;
  }

  .event-name,.end-at{
    background-color: #fff;
    border-collapse: collapse;
    border:1px solid #82ba1d;
    font-size:.8rem;
    padding:.1rem .2rem;
    .info-label{
      color:#82ba1d;
      font-weight: bold;

    }
  }

  .price-area {
    background-color: #fff;
    border:1px solid #7bb600;
    padding:.5rem 1rem;

  }
  .price-info-wrap{
    border:1px solid #ec4200;
    background-color: #fff;
    position: relative;
    .price-info {
      .price-label {
        padding: 1px 4px 0 4px;
        color: #ec4200;
      }
      .price-value {
        font-size: 1.2rem;
        padding: 0 4px;
      }
    }
  }
  .size-info-mobile{
    font-size:0.7rem;
  }
</style>



// WEBPACK FOOTER //
// Confirm.vue?b28c3c7c